/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailTrackingToggleRequest
 */
export interface EmailTrackingToggleRequest {
    /**
     * 
     * @type {boolean}
     * @memberof EmailTrackingToggleRequest
     */
    emailTrackingEnabled: boolean;
}

/**
 * Check if a given object implements the EmailTrackingToggleRequest interface.
 */
export function instanceOfEmailTrackingToggleRequest(value: object): value is EmailTrackingToggleRequest {
    if (!('emailTrackingEnabled' in value) || value['emailTrackingEnabled'] === undefined) return false;
    return true;
}

export function EmailTrackingToggleRequestFromJSON(json: any): EmailTrackingToggleRequest {
    return EmailTrackingToggleRequestFromJSONTyped(json, false);
}

export function EmailTrackingToggleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailTrackingToggleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'emailTrackingEnabled': json['email_tracking_enabled'],
    };
}

  export function EmailTrackingToggleRequestToJSON(json: any): EmailTrackingToggleRequest {
      return EmailTrackingToggleRequestToJSONTyped(json, false);
  }

  export function EmailTrackingToggleRequestToJSONTyped(value?: EmailTrackingToggleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email_tracking_enabled': value['emailTrackingEnabled'],
    };
}

